import { ItemSearchAction } from '../actions/item_search_action'
import { Env } from '../../../core/env';
import { ItemSearchContainer } from '../views/pc/item_search_container';
import { ItemSearchAnalytics } from '../../../core/actions/analytics/item_search_analytics';
import { ItemSimilarSpecSearchAnalytics } from '../../../core/actions/analytics/item_similar_spec_search_analytics';

document.addEventListener('DOMContentLoaded', () => {
    ItemSearchAction.init(Env, ItemSearchContainer);

    new ItemSearchAnalytics(); //NOSONAR

    new ItemSimilarSpecSearchAnalytics(); //NOSONAR
});
